import { MediaElement, MediaMockupPlaceholder } from 'editor/src/store/design/types';
import { MockupRole } from 'editor/src/store/mockup/types';

function isMediaMockupPlaceholder(elt: MediaElement): elt is MediaMockupPlaceholder {
  return elt.type === 'image' && elt.role === MockupRole.Placeholder;
}

export default isMediaMockupPlaceholder;
